class ChangeUserDialogController {
    constructor(translationService) {
        Object.assign(this, { translationService });
    }
}

ChangeUserDialogController.$inject = ['translationService'];

export default ChangeUserDialogController;
